import React from 'react';
import './BmBadge.css';

export type BmBadgeVariant = 'cyd' | 'insight' | 'neutral' | 'warning' | 'negative';

export interface BmBadgeProps {
  variant?: BmBadgeVariant;
  size?: 'sm' | 'lg';
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const BmBadge: React.FC<BmBadgeProps> = ({
  variant = 'neutral',
  size = 'sm',
  children,
  className = '',
  style,
}) => (
  <span
    className={[
      'bm-badge',
      `bm-badge--${variant}`,
      size === 'lg' ? 'bm-badge--lg' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    style={style}
  >
    {children}
  </span>
);

export function isCydMetricId(id: string): boolean {
  return id.includes('cyd');
}

export function isCydRateColumn(columnName: string): boolean {
  return columnName === 'cydRate' || columnName === 'cyd_rate';
}
